import React, { useContext, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import AuthContext from '../context/AuthContext';
import { getLoginHintKeyFromPath } from '../utils/paymentUiMessages';
import { Loading } from './ui';

const ADMIN_DENIED_TOAST_ID = 'admin-route-access-denied';
const ADMIN_LOGIN_REQUIRED_TOAST_ID = 'admin-route-login-required';

function RedirectToLoginForAdmin() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    toast.warning(
      'É necessário iniciar sessão para aceder à área administrativa. A redirecionar para o login.',
      {
        toastId: ADMIN_LOGIN_REQUIRED_TOAST_ID,
        autoClose: 8000,
      }
    );
    navigate('/login', {
      replace: true,
      state: {
        from: location,
        loginHintKey: getLoginHintKeyFromPath(location.pathname),
      },
    });
  }, [navigate, location]);

  return null;
}

function RedirectNonAdmin() {
  const navigate = useNavigate();

  useEffect(() => {
    toast.warning(
      'Acesso negado. Esta área é exclusiva para administradores. Se precisar de permissões, contacte quem gere a loja.',
      {
        toastId: ADMIN_DENIED_TOAST_ID,
        autoClose: 8000,
      }
    );
    navigate('/', { replace: true });
  }, [navigate]);

  return null;
}

const AdminRoute = ({ children }) => {
  const { user, isLoading } = useContext(AuthContext);

  if (isLoading) {
    return <Loading fullScreen message="Carregando área administrativa..." />;
  }

  if (!user) return <RedirectToLoginForAdmin />;

  if (!user.isAdmin) return <RedirectNonAdmin />;

  return children;
};

export default AdminRoute;
